// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".items[data-v-38bffb87]{list-style:none;padding:0;margin:0}.items li[data-v-38bffb87]{margin:0 0 1rem}.items li[data-v-38bffb87]:last-child{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
